import fb from '@/firebaseConfig';

// To Do
//
//  Cancelled subscription
//  Billing error

/*

  STATE

 */

const state = {
  selectedPlan: 'annual',
  plans: {
    annual: {
      planId: 'plan_FKOsHXiqjhJgpN', // Testing plan, replace for Prod
      price: 1100,
      label: 'Test Annual Subscription',
    },
    lifetime: {
      planId: 'plan_FOsZ5tUsvnRsCH', // Testing plan, replace for Prod
      price: 2800,
      label: 'Test Lifetime Subscription',
    },
  },
  // Strip subscription:
  customerId: '',
  subscriptionId: '',
  // subscriptionId: 'sub_FOwYOGwh2GHsWY', // Monthly
  // subscriptionId: 'sub_FZmDrDmJSTyStN', // Long Trial
  // planType: 'lifetime',
  planType: '',
  stripeData: {
    status: '', // active, trialing
    // status: 'trialing', // active, trialing
    currentPeriodEnd: null,
    planAmount: 0,
    trialEnd: null,
    cancelAt: null,
    cancelAtPeriodEnd: false,
    // billing issue?
  },
};

/*

  GETTERS

 */

const getters = {
  exampleGetter: (state, getters, rootState, rootGetters) => {},

  isTrialing: state => state.stripeData.status === 'trialing',
};

/*

  ACTIONS

 */

const actions = {
  exampleAction({ commit, dispatch, state, getters, rootState, rootGetters }, otherParams) {},

  async getSubscription({ commit, state }) {
    const { subscriptionId } = state;
    const getSubscription = fb.functions.httpsCallable('getStripeSubscription');
    try {
      const response = await getSubscription({ subscriptionId });
      console.log('subscription data');
      console.log(response.data);
      const {
        status,
        current_period_end: currentPeriodEnd,
        plan: { amount: planAmount },
        trial_end: trialEnd,
        cancel_at: cancelAt,
        cancel_at_period_end: cancelAtPeriodEnd,
      } = response.data;

      const stripeData = {
        status,
        currentPeriodEnd,
        planAmount,
        trialEnd,
        cancelAt,
        cancelAtPeriodEnd,
      };
      commit('setSubscriptionData', stripeData);
    } catch (error) {
      console.log('Error getting subscription', error);
    }
  },

  updateSelectedPlan({ commit }, planName) {
    commit('setSelectedPlan', planName);
  },

  createSubscription({ state, rootState }, data) {
    const { uid } = rootState.user;
    const { selectedPlan, plans } = state;
    const { planId } = plans[selectedPlan];
    const planType = selectedPlan;
    const stripeData = {
      ...data,
      uid,
      planId,
      planType,
    };
    console.log('stripeData', stripeData);
    const createNewSubscription = fb.functions.httpsCallable('createNewSubscription');
    return createNewSubscription(stripeData);
  },

  updateNewSubscriptionInfo({ commit }, { customer, subscription, planType }) {
    const customerId = customer.id;
    const subscriptionId = subscription.id;
    commit('setSavedSubscription', { customerId, subscriptionId, planType });
    commit('user/setUserType', 'premium', { root: true });
  },
};

/*

  MUTATIONS

 */

const mutations = {
  exampleMutation(state, data) {
    state.property = data;
  },

  setSelectedPlan(state, planName) {
    state.selectedPlan = planName;
  },

  setSavedSubscription(state, stripeSubscription) {
    const { customerId = '', subscriptionId = '', planType = '' } = stripeSubscription;
    state.customerId = customerId;
    state.subscriptionId = subscriptionId;
    state.planType = planType;
  },

  setSubscriptionData(state, stripeData) {
    state.stripeData = { ...stripeData };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
